<template>
  <div class="lg:flex flex-wrap mb-8 content">
    <slot name="prefix" />
    <div
      v-if="$slots.title"
      class="lg:w-1/4 content-title"
    >
      <div
        class="content-sticky md:pl-6 lg:pr-6 lg:pl-0"
        :style="{
          top: (hasTabs ? 10 : 8) + 'rem'
        }"
      >
        <slot name="title" />
      </div>
    </div>
    <div class="lg:w-3/4 space-y-6">
      <div
        v-if="$slots.default"
        class="p-4 md:p-6 lg:p-8 content-body bg-white shadow-md"
      >
        <slot />
      </div>
      <div
        v-if="$slots.cardless"
        class="content-body"
      >
        <slot name="cardless" />
      </div>
    </div>
    <slot name="suffix" />
  </div>
</template>

<script>
export default {
  name: "ContentSection",
  props: {
    hasTabs: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.content-sticky {
  @apply sticky;
  z-index: 10;
}
</style>
